import { Box, Grid } from "@material-ui/core";
import { useNotify, useRedirect } from "ra-core";

import CatandSubCatInput from "../components/CatandSubCatInput";
import HashtagsInput from "../components/HashtagsInput";
import HiddenInputRA from "../components/HiddenInputRA";
import LayoutContainer from "../components/LayoutContainer";
import LeftGridEdit from "../components/LeftGridEdit";
import { Loading } from "ra-ui-materialui";
import ProductValidation from "../../../ValidationRules/ProductValidation";
import RightGridEdit from "../components/RightGridEdit";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import SkipStockInput from "../components/SkipStockInput";
import StatusInput from "../components/StatusInput";
import TextInputRA from "../components/TextInputRA";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";

const ProductEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.Product",
    write: true,
  });
  if (loading) return <Loading />;
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };

  const getHashtagStringtoArray = (hashtagString) => {
    if (!hashtagString || hashtagString === "") return [];
    if (Array.isArray(hashtagString)) return hashtagString;

    const rawHashtags = hashtagString.split(",");

    const result = rawHashtags.map((tag) => {
      tag = tag.trim();
      if (tag[0] !== "#") {
        return "#" + tag;
      }
      return tag;
    });

    return result;
  };
  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
        <LeftGridEdit
          onFailure={onFailure}
          onSuccess={onSuccess}
          {...props}
          validate={ProductValidation}
          transform={(data) => ({
            ...data,
            hashtags: getHashtagStringtoArray(data.hashtags),
          })}
          disabled={!allow}
        >
          <SfBreadcrumbs path="Management/Products/Edit " />
          <Box style={{ margin: 50 }}>
            <TextInputRA required label="Product Code" source="code" disabled />
            <TextInputRA required label="Product name" source="name" />
            <TextInputRA label="Description" source="desc" />

            <TextInputRA
              required
              label="Retail price"
              source="retail_price"
              type="number"
            />
            <SkipStockInput />
            <CatandSubCatInput required />
            <StatusInput />
            {/* <TextInputRA label="Hashtags" source="hashtags" /> */}
            <HashtagsInput />
            {/* <ArrayInput source="hashtags[]">
            <SimpleFormIterator>
              <TextInput source="" label="Tags" />
            </SimpleFormIterator>
          </ArrayInput> */}
            <HiddenInputRA source="currency" initialValue="THB" />
            <HiddenInputRA source="unit" initialValue="Piece" />
            <HiddenInputRA source="status" initialValue="Active" />
            <HiddenInputRA source="type" initialValue="Product" />
          </Box>
        </LeftGridEdit>
        <RightGridEdit resource="products" {...props} />
        {/* <Edit
          mutationMode="pessimistic"
          onSuccess={onSuccess}
          onFailure={onFailure}
          {...props}
        >
          <SimpleForm></SimpleForm>
        </Edit> */}
      </Grid>
    </LayoutContainer>
  );
};

export default ProductEdit;
